// FILECONTENT_START src/common/components/Menu/index.ts
import Menu from "./Menu";
export default Menu;
export type { MenuItemProps } from "./Menu";

// FILECONTENT_END src/common/components/Menu/index.ts